module.exports = __webpack_public_path__ + "assets/img/thumb-Kaplan-Professional-1-Video.108cb269.jpg";